import NProgress from 'nprogress';
/**
 * Middleware którego zadaniem jest oczekiwanie na załadowanie się aplikacji
 * @param next
 */
export default function ({next}) {
    // Uruchamianie paska postępu
    NProgress.configure();
    NProgress.start();
    next();
}